import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

interface PriorItemFormProps extends PropsWithChildren {
    defaultValues: object;
}

const PriorItemForm = ({ children, defaultValues }: PriorItemFormProps) => {

    const formMethods = useForm({defaultValues: defaultValues});

    return (
        <FormProvider {...formMethods}>
            <form className="tw-overflow-x-hidden">
                {children}
            </form>
        </FormProvider>
    );
};

PriorItemForm.displayName = 'PriorItemForm';

export { PriorItemForm };
